export const SOURCE_PARAM = "source";
const SOURCE_STORAGE_KEY = "resume_source";

export function slugifyCompany(company) {
    return company
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
}

export function buildResumeUrl(baseUrl, company, path = "/") {
    const url = new URL(path, baseUrl.replace(/\/$/, "") + "/");
    url.searchParams.set(SOURCE_PARAM, slugifyCompany(company));
    return url.toString();
}

export function getSourceFromUrl(search = window.location.search) {
    const value = new URLSearchParams(search).get(SOURCE_PARAM);
    return value ? slugifyCompany(value) : null;
}

export function persistSource(source) {
    if (!source) {
        return null;
    }

    sessionStorage.setItem(SOURCE_STORAGE_KEY, source);
    return source;
}

export function getStoredSource() {
    return sessionStorage.getItem(SOURCE_STORAGE_KEY);
}

export function getActiveSource(search = window.location.search) {
    const fromUrl = getSourceFromUrl(search);
    if (fromUrl) {
        return persistSource(fromUrl);
    }

    return getStoredSource() || "direct";
}
